
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BI_RADS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/DS/BI_RADS.vue